import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';
import Spinner from '../components/ui/Spinner';

export default function SSOCallback() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <AuthenticateWithRedirectCallback />
      <Spinner size={60} />
    </div>
  );
}
